<template>
    <div class="order-status-description">
        <div class="description-icon">
            <alert-square />
        </div>
        <div class="description-content">
            <div v-if="orderStatus === 'Supplier Added' || orderStatus === 'Suppliers Added' || orderStatus === 'Preferred Supplier Selected'">
                <p>{{ quoteSubmittedDescriptiveMessage }}</p>
            </div>
            <div v-if="orderStatus === 'Order Accepted' || orderStatus === 'Order Placed'">
                <p>{{ orderConfirmedDescriptiveMessage }}</p>
            </div>
            <div v-if="orderStatus === orderStatus === 'Delivery Offered'">
                <p>{{ arrivedInStockDescriptiveMessage }}</p>
            </div>
            <div v-if="orderStatus === 'Contract Implemented' || orderStatus === 'Delivery Arranged'">
                <p>{{ deliveryOrganisedDescriptiveMessage }}</p>
            </div>
            <div v-if="orderStatus === 'Implemented'">
                <p>{{ vehicleDeliveredDescriptiveMessage }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import AlertSquare from "./icons/alert-square";
export default {
    name: "order-status-description",
    components: {AlertSquare},
    props: ['order', 'product'],
    computed: {
        orderStatus() {
            return this.order.orderStatusDescription;
        },

        arrivedInStockDescriptiveMessage() {
            return this.product?.order_statuses_arrived_in_stock_descriptive_message ? this.product.order_statuses_arrived_in_stock_descriptive_message : '';
        },

        deliveryOrganisedDescriptiveMessage() {
            return this.product?.order_statuses_delivery_organised_descriptive_message ? this.product.order_statuses_delivery_organised_descriptive_message : '';
        },

        fundingDocumentsDescriptiveMessage() {
            return this.product?.order_statuses_funding_documents_descriptive_message ? this.product.order_statuses_funding_documents_descriptive_message : '';
        },

        orderConfirmedDescriptiveMessage() {
            return this.product?.order_statuses_order_confirmed_descriptive_message ? this.product.order_statuses_order_confirmed_descriptive_message : '';
        },

        quoteSubmittedDescriptiveMessage() {
            return this.product?.order_statuses_quote_submitted_descriptive_message ? this.product.order_statuses_quote_submitted_descriptive_message : '';
        },

        vehicleDeliveredDescriptiveMessage() {
            return this.product?.order_statuses_vehicle_delivered_descriptive_message ? this.product.order_statuses_vehicle_delivered_descriptive_message : '';
        },

    }
}
</script>

<style scoped lang="scss">
.order-status-description {
    display: flex;

    .description-icon {
        padding-right: 1.5rem;
    }
}
</style>
